export default __webpack_public_path__ + "static/media/none-vaccinate-start-wok-panel.371bbf3e.svg";